// Fuente unica de verdad del SEO por pagina. La usa webpack.config.js para:
//   - generar build/<ruta>/index.html con title, meta, canonical, JSON-LD y texto para bots
//   - generar sitemap.xml
// Para sumar una pagina nueva: agregar el objeto aca + la <Route> en src/index.js.
// Las rutas SIEMPRE en minuscula y con barra final (S3 es sensible a mayusculas).

const SITE = 'https://estudionod.com'
const ORG_ID = `${SITE}/#organization`

const pages = [
  {
    path: '/',
    name: 'Home',
    title: 'Estudio Nod | Architectural Visualisation Studio for Architects',
    description:
      'Estudio Nod is an architectural visualisation studio creating renders, films and 360 experiences for architects, urbanists and developers worldwide.',
    ogDescription:
      'Renders, films and 360 experiences for architects, urbanists and developers. Over 500 projects in 40 countries.',
    h1: 'Estudio Nod: architectural visualisation studio',
    body: [
      'Estudio Nod creates architectural renders, films and 360 experiences for architects, urbanists and developers. We have helped land over 500 projects in 40 countries, working with international practices in the UK, Europe, the US, Australia and the Middle East.',
    ],
    organization: true,
  },
  {
    path: '/about/',
    name: 'About',
    title: 'About Estudio Nod | Architectural Visualisation Studio',
    description:
      'Meet Estudio Nod, an architectural visualisation studio working with Heatherwick Studio, ARUP, IDOM, KPF, Populous, Perkins&Will and Field Operations.',
    ogDescription:
      'The team behind Estudio Nod and what architects say about working with us.',
    h1: 'About Estudio Nod',
    body: [
      'Estudio Nod is an architectural visualisation studio producing renders, films and 360 experiences for architects, urbanists and developers.',
      'Clients include Heatherwick Studio, ARUP, IDOM, KPF, Populous, Perkins&Will and Field Operations. Their architects and designers describe the studio as organised, flexible and quick to understand the narrative a project needs to tell.',
    ],
  },
  {
    path: '/graton/',
    name: 'Graton',
    title: 'Graton by Rockwell Group | Estudio Nod',
    description:
      'Architectural visualisation of the restaurant and bar interiors at Graton Resort & Casino, designed by Rockwell Group. Renders and animation by Estudio Nod.',
    ogDescription:
      'Graton Resort & Casino interiors by Rockwell Group. Architectural renders and animation by Estudio Nod.',
    h1: 'Graton by Rockwell Group',
    place: 'Graton Resort & Casino, Sonoma County, California, USA',
    body: [
      'Graton Resort & Casino in Sonoma County, California, is owned and operated by the Federated Indians of Graton Rancheria. Rockwell Group designed the interiors of a new restaurant and bar as part of the resort\'s expansion.',
      'Estudio Nod produced the architectural visualisation for Rockwell Group: renders and animations that present the atmosphere, materials and lighting of the spaces before they were built, plus a marketing pack. For each approved image we also created a closer companion image and a short vertical video (9:16), all with the same atmosphere, narrative and visual quality.',
    ],
  },
  {
    path: '/nodeul/',
    name: 'Nodeul Island',
    title: 'Nodeul Island by Heatherwick Studio | Estudio Nod',
    description:
      'Architectural visualisation of Nodeul Island, Heatherwick Studio\'s Soundscape park on the Han River, Seoul. Renders and animation by Estudio Nod.',
    ogDescription:
      'Nodeul Island by Heatherwick Studio: a new public park on the Han River, Seoul. Architectural renders and animation by Estudio Nod.',
    h1: 'Nodeul Island by Heatherwick Studio',
    place: 'Nodeul Island, Han River, Seoul, South Korea',
    body: [
      'Nodeul Island is an artificial island on the Han River in the centre of Seoul. Heatherwick Studio is transforming it into a public park for the Seoul Metropolitan Government, under the name Soundscape.',
      'The design is inspired by Seoul\'s mountainous terrain and the patterns of soundwaves. A 1.2 km skywalk of floating islets offers resting spaces with views back to the city, and the ground level holds an arts centre, a public beach and an events podium within a biodiverse landscape that changes with the tides and seasons.',
      'Estudio Nod produced the architectural visualisation for Heatherwick Studio: renders and animations that present the park and its elevated trail, plus a marketing pack. For each approved image we also created a closer companion image and a short vertical video (9:16), all with the same atmosphere, narrative and visual quality.',
    ],
  },
  {
    path: '/vela-viento/',
    name: 'Vela Viento',
    title: 'Vela Viento by Foster + Partners | Estudio Nod',
    description:
      'Architectural visualisation of Vela Viento, Foster + Partners\' 180 m tower for Omniyat in Marasi Bay, Dubai. Renders and animation by Estudio Nod.',
    ogDescription:
      'Vela Viento by Foster + Partners for Omniyat, Marasi Bay, Dubai. Architectural renders and animation by Estudio Nod.',
    h1: 'Vela Viento by Foster + Partners',
    place: 'Marasi Bay, Dubai, United Arab Emirates',
    body: [
      'Vela Viento is an ultra-luxury residential skyscraper in Marasi Bay, Dubai, developed by Omniyat and designed by Foster + Partners. It rises 180 metres over 41 floors and holds 92 residences, with floor-to-ceiling windows wrapped by terraces facing the waterfront and the Burj Khalifa.',
      'Its two structurally separate towers are linked by dining rooms suspended in mid-air, part of the three bridge apartments. Interiors are by Gilles & Boissier and the building is managed by Dorchester Collection.',
      'Estudio Nod produced the architectural visualisation for Foster + Partners: renders and animations that present the towers and their residences, plus a marketing pack. For each approved image we also created a closer companion image and a short vertical video (9:16), all with the same atmosphere, narrative and visual quality.',
    ],
  },
  {
    path: '/form/',
    name: 'Contact form',
    title: 'Contact | Estudio Nod',
    description: 'Get in touch with Estudio Nod.',
    ogDescription: 'Get in touch with Estudio Nod.',
    h1: 'Contact Estudio Nod',
    body: ['Write to hello@estudionod.com.'],
    noindex: true,
  },
]

const organizationJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'ProfessionalService',
  '@id': ORG_ID,
  name: 'Estudio Nod',
  alternateName: ['NOD', 'Nod Studio', 'Estudio NOD'],
  url: `${SITE}/`,
  email: 'hello@estudionod.com',
  description:
    'Architectural visualisation studio creating renders, films and 360 experiences for architects, urbanists and developers.',
  knowsAbout: [
    'Architectural visualisation',
    'Architectural rendering',
    'Architectural films and animation',
    '360 experiences',
    'Urban masterplan visualisation',
  ],
  areaServed: [
    'United Kingdom',
    'Europe',
    'United States',
    'Australia',
    'Middle East',
  ],
  sameAs: [
    'https://www.linkedin.com/company/nod3d/',
    'https://www.instagram.com/estudionod/',
    'https://www.behance.net/estudionod',
  ],
}

function jsonLdFor(page) {
  const url = SITE + page.path
  const graph = [
    {
      '@type': 'WebPage',
      '@id': `${url}#webpage`,
      url,
      name: page.title,
      description: page.description,
      inLanguage: 'en',
      isPartOf: { '@id': ORG_ID },
      publisher: { '@id': ORG_ID },
      ...(page.place && { about: { '@type': 'Place', name: page.place } }),
    },
  ]
  if (page.path !== '/') {
    graph.push({
      '@type': 'BreadcrumbList',
      itemListElement: [
        { '@type': 'ListItem', position: 1, name: 'Home', item: `${SITE}/` },
        { '@type': 'ListItem', position: 2, name: page.name, item: url },
      ],
    })
  }
  if (page.organization) graph.push(organizationJsonLd)
  return JSON.stringify({ '@context': 'https://schema.org', '@graph': graph })
    .replace(/</g, '\\u003c')
}

// Ya expandido para el template: url canonica, nombre de archivo y JSON-LD.
const resolved = pages.map((p) => ({
  ...p,
  url: SITE + p.path,
  filename: p.path === '/' ? 'index.html' : `${p.path.slice(1)}index.html`,
  jsonLd: jsonLdFor(p),
}))

module.exports = { SITE, pages: resolved }
